export async function getRecaptchaToken(action = "registration", siteKey) {
    // siteKey should be passed in from config for full dynamic config
    if(!siteKey) {
        console.warn("reCAPTCHA site key missing.");

        return null;
    }

    if(!window.grecaptcha?.enterprise) {
        console.warn("reCAPTCHA not ready.");
        return null;
    }

    return new Promise((resolve, reject) => {
        window.grecaptcha.enterprise.ready(() => {
            window.grecaptcha.enterprise
                .execute(siteKey, { action })
                .then((token) => {
                    resolve(token);
                })
                .catch((err) => {
                    console.error("reCAPTCHA execute error:", err);
                    reject(null);
                });
        });
    });
}
